import { useParams } from "react-router-dom";
import { Contact } from "../Contact";
import ContactFormTabs from "./ContactFormTabs";
import { useFetchContact } from "../Hooks/useFetchContact";
import { useUpdateContact } from "../Hooks/useUpdateContact";
import { useDeleteContact } from "../Hooks/useDeleteContact";

export default function EditContact() {
  const { contactId } = useParams();
  const { data: contact } = useFetchContact(contactId);
  const { mutate: updateContact } = useUpdateContact(contactId);
  const { mutate: deleteContact } = useDeleteContact(contactId);

  return (
    <ContactFormTabs
      title="Edit Contact"
      contact={contact}
      onSave={(it: Contact) => updateContact(it)}
      onDelete={() => deleteContact(contactId)}
    />
  );
}
